<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div class="col-md-6">
        <label for="point_name" class="form-control-label">
          Nombre<span class="required">*</span>
        </label>
        <input
          id="point_name"
          v-model="formModel.name"
          :class="['form-control', v.name.$error ? 'is-invalid' : '']"
          type="text"
          placeholder=""
        />
        <p v-if="v.name.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.name.$errors[0].$message }}
          </small>
        </p>
        <label for="lang" class="form-control-label w-100">
          Idioma<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.lang"
            size="large"
            class="w-100"
        >
          <el-option
              v-for="selectItem in langs"
              :key="selectItem.id"
              :value="selectItem.value"
              :label="selectItem.name"
          />
        </el-select>
        <p v-if="v.lang.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.lang.$errors[0].$message }}
          </small>
        </p>
        <label for="experience" class="form-control-label w-100">
          Experiencia<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.experience"
            size="large"
            class="w-100"
        >
          <el-option
              v-for="selectItem in experiences"
              :key="selectItem.id"
              :value="selectItem.id"
              :label="selectItem.name"
          />
        </el-select>
        <p v-if="v.experience.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.experience.$errors[0].$message }}
          </small>
        </p>
        <label for="description" class="form-control-label">
          Descripción<span class="required">*</span>
        </label>
        <textarea
            rows="10"
            id="description"
            v-model="formModel.description"
            :class="[ 'form-control',v.description.$error ? 'is-invalid' : '']"
            type="text"
            placeholder=""
        />
        <p v-if="v.description.$error" class="invalid-feedback invalid-field mb-0">
          <small>
            {{ v.description.$errors[0].$message }}
          </small>
        </p>
      </div>
      <div class="col-md-6">
        <label for="latitude" class="form-control-label">
          Latitud<span class="required">*</span>
        </label>
        <input
            id="latitude"
            v-model="formModel.latitude"
            :class="[
                        'form-control',
                        v.latitude.$error ? 'is-invalid' : '',
                      ]"
            type="text"
            placeholder=""
        />
        <p v-if="v.latitude.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.latitude.$errors[0].$message }}
          </small>
        </p>
        <label for="longitude" class="form-control-label">
          Longitud<span class="required">*</span>
        </label>
        <input
            id="latitude"
            v-model="formModel.longitude"
            :class="[
                        'form-control',
                        v.longitude.$error ? 'is-invalid' : '',
                      ]"
            type="text"
            placeholder=""
        />
        <p v-if="v.longitude.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.longitude.$errors[0].$message }}
          </small>
        </p>
        <label for="video" class="form-control-label">
          Video<span class="required">*</span>
        </label>
        <input
            type="file"
            id="video"
            @change="handleFileUpload"
            :class="[ 'form-control']"
            placeholder=""
        />
        <div class="img-thumbnail mt-3">
          <video class="w-100 p-2" muted autoplay v-if="previewUrl" :src="previewUrl"></video>
          <p v-if="v.videoUrl.$error" class="invalid-feedback mb-0">
            <small>
              {{ v.videoUrl.$errors[0].$message }}
            </small>
          </p>
        </div>

      </div>
    </div>
    <div class="mt-3">
      <button
        type="submit"
        class="float-end btn btn-primary text-white bg-blue-600 rounded-lg border border-primary hover:bg-blue-900">
        {{ buttonText }}
      </button>
      <button
        class="me-2 float-end btn btn-primary text-danger bg-white border border-danger rounded-lg hover:bg-blue-900"
        @click="handleCancel"
      >
        Cancelar
      </button>
    </div>
  </form>
</template>

<script setup>
import {ref, defineProps, computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from 'sweetalert2';
import {languageList} from "@/utils/languages";
const store = useStore();
const router = useRouter();

const props = defineProps({
   entity: {
     type: Object,
     required: false
   },
  action: {
     type: String,
    required: true
  }
})
const formModel = ref(props.entity|| {});
const langs = languageList()
const experiences = computed(() => store.state.experience.experiences);
const buttonText = computed(() => props.action === 'create' ? 'Crear' : 'Guardar cambios');

const videoFile = ref(null);
const previewUrl = ref(formModel.value.videoUrl);

const getExperiences = async () => {
  return await store.dispatch("experience/getExperiences");
};

onMounted(() => {
  getExperiences();
  if(props.entity.experience){
    formModel.value.experience = props.entity.experience.id
  }
  if(props.entity.type){
    formModel.value.type = props.entity.type.id
  }
});

const rules = computed(() => {
  return {
    name: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    type: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    longitude: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    lang: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    latitude: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    experience: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    description: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    videoUrl: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    }
  };
});

const v$ = useVuelidate(rules, formModel);
const v = v$.value;

const handleSubmit = () => {
  v$.value.$validate();
  if (!v$.value.$invalid) {
    let payload;
    if (videoFile.value) {
      payload = new FormData();
      for (const key in formModel.value) {
        payload.append(key, formModel.value[key]);
      }
      // Agregar el archivo
      payload.append('file', videoFile.value);
    } else {
      payload = {...formModel.value};
    }
    if(props.action === 'create'){
      createEntity(payload);
    }else{
      updateEntity(payload);
    }
  }
};

const handleCancel = () => {
  router.push({ name: "Puntos", params: {} });
};

const updateEntity = async (data) => {
    await store.dispatch("point/edit", data).then(async (res) => {
      if (res && res.status && (res.status === 200 || res.status === 201)) {
        await Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Punto de interés editado satisfactoriamente.',
          showConfirmButton: false,
          timer: 3000
        })
        await router.push({name: "Puntos", params: {}});
      } else{
          await Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: res.response.data.detail,
            showConfirmButton: false,
            timer: 3000
          })
        }

    })

}

const createEntity = async (data) => {
  await store.dispatch("point/add", data).then(async (res) => {
    if (res && res.status && (res.status === 200 || res.status === 201)) {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Punto de interés creado satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
      router.push({name: "Puntos", params: {}});
    } else {
      await Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: res.response.data.detail,
        showConfirmButton: false,
        timer: 3000
      })
    }

  }).catch(async error => {
    console.log(error)
    await Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: error.response.detail,
      showConfirmButton: false,
      timer: 3000
    })
  })
}

const handleFileUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    videoFile.value = file;
    previewUrl.value = URL.createObjectURL(file);
    formModel.value.videoUrl = URL.createObjectURL(file);
  }
};
</script>
